interface ISortIdentityParams {
  firstName: string;
  lastName: string;
}

export const sortIdentity = <T extends ISortIdentityParams>(arrayToSort: T[]) => {
  return arrayToSort.sort((a, b) => {
    if (a.lastName > b.lastName) {
      return 1;
    }
    if (a.lastName < b.lastName) {
      return -1;
    }
    if (a.firstName > b.firstName) {
      return 1;
    }

    return a.firstName === b.firstName ? 0 : -1;
  });
};
